export enum GeneType {
  NotTested = 'NotTested',
  Inconclusive = 'Inconclusive',
  Nn = 'Nn',
  Xn = 'Xn',
  Xx = 'Xx',
  XnOrXx = 'XnOrXx'
}
